.container.faq-container { 
  padding: 40px 0;
}

.container.faq-container:has(+ .container.faq-container) { 
  padding: 40px 0 20px; 

  +.container.faq-container { 
    padding: 20px 0;

    &:last-of-type { padding: 20px 0 40px; }
  }
}
.kdx-faq {
  background-color: #FFFFFF;
  color: $gray-dark;
  box-shadow: 0px 6px 17px rgba(0, 61, 107, 0.1);
  border-radius: 6px;
  overflow: hidden;
  margin: 15px 0;
  transition: transform 350ms;

    h3 {
      margin: 0;
      transition: all 350ms;
      user-select: none;

      .accordion-trigger {
        width: 100%;
        text-align: left;
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        align-items: center;
        border: none;
        background-color: transparent;

        .icon {
          display: inline-block;
          transition: transform 350ms;
          margin-right: 10px;
          height: 44px;
          width: 44px;
          border-radius: 50%;
          background-color: #FFFFFF;
          transform: translateY(0);
          box-shadow: 0px 12px 22px rgba(45, 47, 59, 0.25);
          transition: all linear 0.125s;
          position: relative;

          &:hover, &:focus {
            background-color: $secondary;

            svg { fill: #FFFFFF; }
          }
        }
    
        svg {
          @include svg-format(21px, 14px, $secondary);
          margin-top: 2px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }

        .accordion-title {
          font-weight: 700;
          color: $gray-dark;
          width: calc(100% - 54px);
          padding: 10px 16px 10px 20px;
          @include text-size(20);
        }
    
      }
      
    }
    &:hover, &:focus {
      background-color: $primary;
      outline: none;
      transform: translateY(-2px);
      transition: all 0.3s ease-out;

      .accordion-trigger {
  
        .accordion-title {
          color: #FFFFFF;
        }
      }

    }
  
    &.open {
      
      h3 {
        
        .accordion-trigger {

          .accordion-title {
            color: $gray-dark;
          }
        }
      }

      &:hover, &:focus {
        background-color: #FFFFFF;
        transform: translateY(0px);

        h3 {
          .accordion-trigger {
            .icon {
              &:hover, &:focus {
  
                svg { fill: #FFFFFF; }
              }
            }
            .accordion-title {
              color: $gray-dark;
            }
          }
        }
      }
    }

  .kdx-faq-content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 500ms;
  }

  .kdx-faq-content-inner {
    padding: 0px 20px 30px 20px;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;

    p {
      padding-bottom: 0;

      // Handle multiple p tags placed in faq content
      & + p {
        padding-top: 10px;
      }
    }
  }

  &.open {
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.1);

    h3 {
      color: $gray-dark;

      .icon {
        transform: rotate(180deg);
        box-shadow: 0px -12px 17px rgba(45, 47, 59, 0.25);
      }

      &:hover, &:focus {
        background: none;
        color: $gray-dark;

        .icon {
          svg {
            fill: $secondary;
          }
        }
      }
    }

    .kdx-faq-content {
      max-height: 4000px;
	  
      &.large-zone {
      max-height: 20000px;
      }
    }
    .kdx-faq-content-inner { opacity: 1; }
  }
}

@include media-breakpoint-down(md) {
  .container.faq-container {

    padding-block: 30px;
  
    .kdx-faq {
      h3 {
        @include text-size(16);
  
        .accordion-trigger {
          .icon {
            height: 28px;
            width: 28px;
          }
        }
  
        svg {
          @include svg-format(8px, 15px, $primary);
        }
      }
    }
  }
}
